<ng-container *transloco="let t">
  <section class="content-products">
    <div class="ui-title">
      <a class="ui-item-link" [routerLink]="['../']">
        <pxw-icon icon="back"></pxw-icon>
      </a>
      <div class="title-wrapper">
        {{ t('productsByTag.title') }}:&nbsp;
        <span class="tag-title">{{ productTag()?.tag }}</span>
      </div>
      <div class="action-buttons">
        @if (displayShareButton()) {
          <app-share-button
            [url]="shareUrl()"
            [shareText]="t('productList.shareText')"
            [buttonColor]="'theme2-contrast'"
          />
        }
      </div>
    </div>
    @if (productTag()) {
      <pxw-item-list
        groupingStrategy="category"
        [itemListGroups]="productsByTag() | pxwItemListGroupProductsByCategory: categories()"
        [emptyListText]="t('productsByTag.emptyList')"
        [itemHeight]="90"
        [rememberScrollSettings]="{ key: 'products-by-tag', context: tagId() }"
        [autoHideSlider]="true"
      >
        <ng-template #groupHeadingTemplate let-groupItem="groupItem" let-category="group">
          <h2 class="group-heading">
            <span class="title">
              {{ category.name }}
              <span class="count">({{ groupItem.indexedItems.length }})</span>
            </span>
          </h2>
          @if ((category | pxwIsCategoryAvailable$ | async) === false) {
            <div class="not-available-wrapper">
              <pxw-alert class="not-available-alert" type="warning" size="sm">
                <pxw-icon icon="clock" />
                <div class="not-available-content">
                  {{ t('categoryAvailability.productsNotAvailable') }}
                  <pxw-button
                    color="yellow"
                    size="sm"
                    [rounded]="true"
                    (click)="categoryAvailabilityDialog.open(category)"
                  >
                    {{ t('categoryAvailability.checkSchedule') }}
                  </pxw-button>
                </div>
              </pxw-alert>
              <pxw-category-availability-dialog #categoryAvailabilityDialog />
            </div>
          }
        </ng-template>
        <ng-template
          #listItemTemplate
          let-category="group"
          let-product="item"
          let-listIndex="index"
        >
          <app-product-list-item
            class="product-list-item"
            [id]="product.id"
            [name]="product.name"
            [image]="product.images?.[0]"
            [price]="product.price"
            [priceDiscount]="product.priceDiscount"
            [sku]="product.sku"
            [displaySku]="displaySku()"
            [isAvailable]="category | pxwIsCategoryAvailable$ | async"
            [withoutStock]="(product | pxwStockIsOutOfStock | async) ?? false"
            [purchaseRestrictions]="product"
            [purchaseOptions]="purchaseOptions()"
            [tag]="product.primaryTag"
            [presentationItems]="product.presentations?.items"
            [currencySymbol]="currencySymbol()"
            [detailRoute]="['/categoria', product.categoryId, 'producto', product.id]"
            [detailRouteQueryParams]="{ t: tagId() }"
            [listIndex]="listIndex"
            [promotions]="getPromotionsForProduct(product.id)"
          ></app-product-list-item>
        </ng-template>
      </pxw-item-list>
    } @else {
      <div class="ui-loader ui-loader--with-overlay">
        <pxw-icon icon="loading" [spin]="true" />
      </div>
    }
  </section>
</ng-container>
